import ShopArticleModelBase from '../_generated/modelBases/shop-article-model-base';

export default class ShopArticleModel extends ShopArticleModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
